module.exports = __webpack_public_path__ + "img/logo1.4137a47e.png";